import Loadable from 'react-loadable';

import type { PartialRoute } from '@rover/react-app/src/routes/training';
import TrainerProfileAdminToolbar from '@rover/react-lib/src/pages/training/PublicTrainerProfilePage/components/TrainerProfileAdminToolbar';
import retry from '@rover/rsdk/src/modules/Network/retry';

import Loading from '../../client/Loading';

const TrainerProfileDetailsPage = Loadable({
  loader: () =>
    retry(
      () =>
        import(
          /* webpackChunkName: "TrainerProfileDetailsPage" */ '@rover/react-lib/src/pages/training/TrainerProfileDetailsPage'
        )
    ),
  loading: Loading,
});

const TrainerEducationPage = Loadable({
  loader: () =>
    retry(
      () =>
        import(
          /* webpackChunkName: "TrainerEducationPage" */ '@rover/react-lib/src/pages/training/EducationPage/EducationPage'
        )
    ),
  loading: Loading,
});

const PublicTrainerProfilePage = Loadable({
  loader: () =>
    retry(
      () =>
        import(
          /* webpackChunkName: "PublicTrainerProfilePage" */ '@rover/react-lib/src/pages/training/PublicTrainerProfilePage'
        )
    ),
  loading: Loading,
});

export const authenticated: PartialRoute[] = [
  {
    path: '/provider-profile/training-details',
    pageName: 'trainer-profile-details-management',
    component: TrainerProfileDetailsPage,
    componentName: 'TrainerProfileDetailsPage',
    pageCategory: 'trainer-profile-details',
  },
  {
    path: '/provider-profile/training-education',
    pageName: 'training-education-management',
    component: TrainerEducationPage,
    componentName: 'TrainerEducationPage',
    pageCategory: 'training-education',
  },
];

export const unauthenticated: PartialRoute[] = [
  {
    path: '/training/members/:slug/',
    pageName: 'public-trainer-profile',
    component: PublicTrainerProfilePage,
    componentName: 'PublicTrainerProfilePage',
    pageCategory: 'public-trainer-profile',
    toolbarComponent: TrainerProfileAdminToolbar,
  },
];
